import { fetchUserTickets } from '../../../services/userTickets';
import { TicketResponse, GetUserTicketsParams } from '../types/queryTypes';

export async function getUserTickets({
  userId,
  sprintId,
  shadowTo,
}: GetUserTicketsParams): Promise<
  Array<{
    id: string;
    label: string;
    value: string;
    completionPercentage: number;
    status: string;
  }>
> {
  const response = await fetchUserTickets(userId, shadowTo, {
    sprintId,
  });
  return (response as TicketResponse[]).map((ticket) => ({
    id: ticket.id,
    label: `${ticket.ticket_number}: ${ticket.title}`,
    value: ticket.id,
    status: ticket.status,
    completionPercentage: ticket?.completion_percentage ?? 0,
  }));
}
